<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
      <v-row>
        <v-col
          cols="12"
          :md="6"
          class="pt-0 pb-1"
          v-if="isEditing"
        >
          <ValidationProvider
            name="Party ID"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="record.partyId"
              label="Party Id"
              placeholder=" "
              outlined
              dense
              :readonly="true"
            ></v-text-field>
          </ValidationProvider>
        </v-col>

        <v-col
          cols="12"
          :md="6"
          class="pt-0 pb-1"
        >
          <ValidationProvider
            name="Business Name"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="record.businessName"
              label="Business Name"
              placeholder=" "
              outlined
              dense
              :readonly="false"
            ></v-text-field>
          </ValidationProvider>
        </v-col>

        <v-col
          cols="12"
          :md="6"
          class="pt-0 pb-1"
        >
          <ValidationProvider
            name="Business Trading Name"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="record.businessTradingName"
              label="Business Trading Name"
              placeholder=" "
              outlined
              dense
              :readonly="false"
            ></v-text-field>
          </ValidationProvider>
        </v-col>


        <v-col cols="12" :md="'6'" class="pt-0 pb-1">
          <ValidationProvider
            name="Business Size"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="businessSize"
              label="Business Size"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="record.businessSize"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col
          cols="12"
          :md="6"
          class="pt-0 pb-1"
        >
          <ValidationProvider
            name="Project Code"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="record.projectCode"
              label="Project Code"
              placeholder=" "
              outlined
              dense
              :readonly="false"
            ></v-text-field>
          </ValidationProvider>
        </v-col>

        <v-col
          cols="12"
          :md="6"
          class="pt-0 pb-1"
        >
          <ValidationProvider
            name="Business ID(ABN or ACN)"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="record.businessId"
              label="Business ID(ABN or ACN)"
              placeholder=" "
              outlined
              dense
              :readonly="false"
            ></v-text-field>
          </ValidationProvider>
        </v-col>

      </v-row>

      <div class="text-right mb-7">
        <v-btn
          class="primary"
          :disabled="wholesalerAccount == 0"
          @click="submit"
        >Submit</v-btn
        >
      </div>
    </ValidationObserver>
  </div>
</template>

<script>

export default {
  name: "organisation-form",
  props:{
    isEditing: { type: Boolean },
    query:{type:Object},
    wholesalerAccount:{type: Number}
  },
  data: () => ({
    record: {},
    businessSize:[
      { text: "Enterprise", value: "Enterprise", disabled: false },
      { text: "Government", value: "Government", disabled: false },
      { text: "Medium", value: "Medium", disabled: false },
      { text: "Micro", value: "Micro", disabled: false },
      { text: "Small", value: "Small", disabled: false },
      { text: "Wholesale", value: "Wholesale", disabled: false },
    ]
  }),
  methods:{
    submit() {
      let vm = this;
      let payload = {};
      payload = {
        organisation:{
          businessName:vm.record.businessName,
          businessTradingName:vm.record.businessTradingName,
          businessSize:vm.record.businessSize.value != null?vm.record.businessSize.value:vm.record.businessSize,
          projectCode:vm.record.projectCode,
          businessId:vm.record.businessId
        }
      };
      if(!vm.isEditing)
      {
        payload.wholesalerAccountNumber = vm.wholesalerAccount;
        vm.createOrganisationAsync(payload).then((data) => {
          vm.$emit("close", data);
        });
      }else{
        payload.organisation.id = vm.record.partyId;
        payload.wholesalerAccountNumber = vm.query.wholesalerAccountNumber;
        vm.updateOrganisationAsync(payload).then((data) => {
          vm.$emit("close", data);
        });
      }
    }
  },
  beforeMount() {
    let vm=this;
    if(vm.isEditing)
    {
      vm.record = vm.query;
    }
  },
}
</script>

<style scoped>

</style>
